import React from 'react';
import { I18n } from '@fiverr-private/i18n-react';
import { Tooltip, Icon } from '@fiverr-private/fit';
import { grey_1100 } from '@fiverr-private/sass/helpers';
import { r_repeat } from '@fiverr-private/icons';
import { TYPE, COPY_ROOT } from './constants';

/**
 * get contant styles
 * @desc this method returns the content of the badge according to badge type
 * @param {string} type
 * @returns {object} - includes the className style and content
 */
export const getContentStyles = type => {
    switch (type) {
        case TYPE.PRO: {
            return {
                classNameStyle: 'is-pro',
                content: (
                    <Tooltip className="expert-card-badge-tooltip tbody-8"
                        boxContentClassName="tooltip-box-content"
                        content={<I18n k={`${COPY_ROOT}.pro_tooltip`}/>}>
                        <I18n k={`${COPY_ROOT}.pro_verified`}/>
                    </Tooltip>
                )
            };
        }
        case TYPE.BUSINESS: {
            return {
                classNameStyle: 'business',
                content: <I18n k={`${COPY_ROOT}.fiverr_business`}/>
            };
        }
        case TYPE.FIVERR_CHOICE: {
            return {
                content: (
                    <Tooltip className="expert-card-badge-tooltip"
                        boxContentClassName="tooltip-box-content"
                        content={<I18n k="gig_page_perseus.overview.fiverr_choice"/>}
                        position={Tooltip.POSITIONS.BOTTOM}>
                        <span className="fiverr-choice"/>
                    </Tooltip>
                )
            };
        }
        case TYPE.LOYALTY: {
            return {
                classNameStyle: 'loyalty',
                content: (
                    <div className="flex">
                        <Icon className="repeat-icon" color={grey_1100}>{r_repeat}</Icon>
                        <span className="m-l-8">
                            <I18n k={`${COPY_ROOT}.loyalty`}/>
                        </span>
                    </div>
                )
            };
        }
        default: {
            return {
                content: ''
            };
        }
    }
};
